import {Component, Input, OnInit} from '@angular/core';
import {ContentService} from "../../services/content.service";
import {LangService} from "../../services/lang.service";
import {ToastService} from "../../services/toast.service";

@Component({
    selector: 'app-block-guide-rate-feedback',
    templateUrl: './block-guide-rate-feedback.component.html',
    styleUrls: ['./block-guide-rate-feedback.component.scss'],
    standalone: false
})
export class BlockGuideRateFeedbackComponent implements OnInit {
    @Input() item: any;

    showFeedback = false;
    feedback: any = "";
    guideToken = "";
    finishedRating = false;
    constructor(
        private contentService: ContentService,
        public lang: LangService,
        public toastService: ToastService,
    ) {
    }
    ngOnInit() {
    }

    /**
     * Rate Guide
     * @param type
     */
    rateGuide(type: string = 'positive') {
        this.contentService.rateGuide(this.item, type)
            .then(response => {
                this.showFeedback = true;
                this.guideToken = response.data.guide_token;
            })
            .catch((error: any) => {
                this.finishedRating = true;
                this.showFeedback = true;
            })

        this.toastService.toast(
            this.lang.data['feedback.confirmation'],
            'success',
        );
    }

    sendFeedback() {
        if (this.feedback.length === 0) return;

        this.contentService.feedbackGuide(this.guideToken, this.feedback)
            .then(
                () => {
                    this.finishedRating = true;
                    // this.toastService.toast(
                    //     this.lang.data['feedback.confirmation'],
                    //     'success',
                    // );
                })
            .catch(() => this.finishedRating = true)
    }


}
